import { render, staticRenderFns } from "./SurveyResults.vue?vue&type=template&id=e4a920f6&"
import script from "./SurveyResults.vue?vue&type=script&lang=js&"
export * from "./SurveyResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports